import reachability from './reachability'

const externalServices = {
  reachability,
}

export default externalServices
